export const tabToSelectView = (e: React.KeyboardEvent<HTMLElement>): void => {
  if (e.key === 'Tab' && e.shiftKey) {
    const switchViewEl = document.getElementById('switch-view-lv') as HTMLElement;
    if (switchViewEl) {
      e.preventDefault();
      switchViewEl.focus();
    }
  }
};